const BASE_URL: string = process.env.NEXT_PUBLIC_API_URL ?? '';
const COMMON: string = '/api/v1/';
const YOTI_ID = process.env.NEXT_PUBLIC_YOTI_ID;

export const API_CONFIG = {
   baseUrl: `${BASE_URL}${COMMON}`,
   timeout: 10000,
   retries: 3,
   YOTI_ID,
   endpoints: {
      users: '/users',
      products: '/products',
      auth: {
         login: '/auth/login',
         register: '/auth/register',
         refresh: '/auth/refresh-token',
      },
   },
};
